import { render, staticRenderFns } from "./freeSpin.vue?vue&type=template&id=1b6ac476&scoped=true"
import script from "./freeSpin.vue?vue&type=script&lang=js"
export * from "./freeSpin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6ac476",
  null
  
)

export default component.exports